import { getAccessToken, renewToken, signIn, authEnabled } from './auth';

export const apiUrl = (path = '/') => {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
};

const withToken = (init = {}, token) => {
  if (!token) return init;
  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${token}`);
  return { ...init, headers };
};

/**
 * fetch() for the backend. Same signature and return value as before, so no
 * caller changes: when sign-in is active it adds the access token, and on a
 * 401 renews the token once and retries. If renewal fails the session is over
 * and the user is sent to sign in again (the draft-protection prompt still
 * fires first if there is unpublished work).
 */
export const apiFetch = async (path, init) => {
  const url = apiUrl(path);
  if (!authEnabled()) return fetch(url, init);

  let res = await fetch(url, withToken(init, await getAccessToken()));
  if (res.status !== 401) return res;

  const renewed = await renewToken();
  if (renewed) {
    res = await fetch(url, withToken(init, renewed.access_token));
    if (res.status !== 401) return res;
  }
  signIn();
  return res;
};

/**
 * Download a file from the backend. A plain <a href> or window.open cannot
 * carry the token, so fetch it with apiFetch and save the result.
 */
export const downloadFile = async (path, fallbackName, init) => {
  const res = await apiFetch(path, init);
  if (!res.ok) throw new Error(`Download failed: HTTP ${res.status}`);
  const cd = res.headers.get('Content-Disposition') || '';
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
  const name = m ? decodeURIComponent(m[1]) : fallbackName;
  const blob = await res.blob();
  const href = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = name || 'download';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
};
